"use client";

import { useEffect, useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function Hero() {
  const heroRef = useRef<HTMLDivElement>(null);
  const [scrollY, setScrollY] = useState(0);
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(false);
  useEffect(() => {
    const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    setPrefersReducedMotion(mediaQuery.matches);
    const handleChange = (e: MediaQueryListEvent) => {
      setPrefersReducedMotion(e.matches);
    };
    mediaQuery.addEventListener("change", handleChange);
    return () => {
      mediaQuery.removeEventListener("change", handleChange);
    };
  }, []);
  useEffect(() => {
    if (prefersReducedMotion) return;
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [prefersReducedMotion]);
  const parallaxOffset = prefersReducedMotion ? 0 : scrollY * 0.02;
  return <section ref={heroRef} className="relative min-h-screen w-full overflow-hidden bg-background-dark">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1507189/img/construction_site_hero_background.png)",
      transform: `translateY(${parallaxOffset}px)`,
      transition: prefersReducedMotion ? "none" : "transform 0.1s ease-out"
    }}>
        <div className="absolute inset-0 bg-background-dark/60" />
      </div>

      {}
      <div className="relative z-10 flex min-h-screen items-center justify-center px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-4xl text-center">
          <h1 className={`font-display text-4xl font-bold tracking-tight text-foreground-dark sm:text-5xl md:text-6xl lg:text-7xl ${prefersReducedMotion ? "" : "animate-fade-in-up"}`}>
            Equipment Leasing Solutions for Construction
          </h1>

          <p className={`mt-6 text-lg text-foreground-dark/90 sm:text-xl md:text-2xl ${prefersReducedMotion ? "" : "animate-fade-in-up-delay-100"}`}>
            Partnering with Sunbelt Rentals and United Rentals to deliver
            reliable equipment delivery and pickup services across California
          </p>

          <div className={`mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row ${prefersReducedMotion ? "" : "animate-fade-in-up-delay-200"}`}>
            <Button asChild size="lg" className="hover-lift w-full bg-primary px-8 py-4 text-base font-semibold text-foreground-primary shadow-medium hover:bg-primary-hover sm:w-auto">
              <Link to="#contact">Get a Quote</Link>
            </Button>

            <Button asChild variant="outline" size="lg" className="w-full border-2 border-foreground-dark/40 bg-transparent px-8 py-4 text-base font-semibold text-foreground-dark hover:bg-foreground-dark/10 sm:w-auto">
              <Link to="#services">Our Services</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}